import { forwardRef, ReactElement, Ref } from 'react'
import ReactSelect, { GroupBase } from 'react-select'
import clsx from 'clsx'

import { SelectOption, SelectProps } from './Select.types'

const ForwardSelect = <
  Option extends SelectOption,
  IsMulti extends boolean,
  Group extends GroupBase<Option> = GroupBase<Option>,
>(
  props: SelectProps<Option, IsMulti, Group>,
  ref: Ref<any>,
) => {
  const { className, ...selectProps } = props

  return (
    <ReactSelect
      ref={ref}
      className={clsx('CustomReactSelect ReactSelect', className)}
      classNamePrefix="ReactSelect"
      {...selectProps}
    />
  )
}

// forwardRef can't use generics. Workaround:
// https://stackoverflow.com/a/58473012
export const Select = forwardRef(ForwardSelect) as <
  Option extends SelectOption,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>,
>(
  props: SelectProps<Option, IsMulti, Group> & { ref?: Ref<any> },
) => ReactElement
